import React, { useState } from "react"

import { Button, Grid } from "@material-ui/core"

import { useHistory } from "react-router-dom"
import useStyles from "@/pages/Tools/styles"
import HardCodedUtil from "@/shared/utils/hardcoded"

type ToolName = "clear-message-queue" | "find-chat-by-protocol" | "mass-notify-subscriptions" | "block-or-unblock-mass-subscriptions" | "search-integrations-or-bots-data-by-webhook-url" | "create-admin-account"
type ToolProps = {
	key: ToolName
	title: string
	pagePath: string
}

const tools: ToolProps[] = [
	{
		key: "clear-message-queue",
		title: "Limpar fila de mensagens",
		pagePath: "/clear-message-queue"
	},
	{
		key: "find-chat-by-protocol",
		title: "Buscar chat por protocolo",
		pagePath: "/find-chat-by-protocol"
	},
	{
		key: "mass-notify-subscriptions",
		title: "Notificar Assinaturas em massa",
		pagePath: "/mass-notify-subscriptions"
	},
	{
		key: "block-or-unblock-mass-subscriptions",
		title: "Bloquear/Desbloquear assinaturas em massa",
		pagePath: "/block-or-unblock-mass-subscriptions"
	},
	{
		key: "search-integrations-or-bots-data-by-webhook-url",
		title: "Buscar dados de integrações ou bots por URL de webhook",
		pagePath: "/search-integrations-or-bots-data-by-webhook-url"
	},
	{
		key: "create-admin-account",
		title: "Criar conta de administrador",
		pagePath: "/create-admin-account"
	}
]

const MASS_SUBSCRIPTION_TOOLS: ToolName[] = ["mass-notify-subscriptions", "block-or-unblock-mass-subscriptions"]

const Tools = () => {
	const history = useHistory()
	const classes = useStyles()
	const [isAnyToolLoading, setIsAnyToolLoading] = useState<boolean>(false)

	const basePath = "/tools"

	return (
		<Grid
			container
			className={classes.buttonContainer}
		>
			{
				tools?.map((renderedTool, toolIndex) => {
					const isMassSubscriptionTool = MASS_SUBSCRIPTION_TOOLS.includes(renderedTool.key)
					const hasPermissionForUseBulkSubscriptionsActions = HardCodedUtil.canUseBulkSubscriptionsActions()

					const hideMassSubscriptionsTools = isMassSubscriptionTool && !hasPermissionForUseBulkSubscriptionsActions

					if (hideMassSubscriptionsTools) {
						return null
					}

					return (
						<Grid
							item
							key={toolIndex}
						>
							<Button
								color="primary"
								variant="contained"
								id={renderedTool.key}
								className={classes.toolButton}
								fullWidth
								disabled={isAnyToolLoading}
								type="button"
								onClick={() => {
									setIsAnyToolLoading(true)
									history.push(`${basePath}${renderedTool.pagePath}`)
									setIsAnyToolLoading(false)
								}}
							>
								{renderedTool.title}
							</Button>
						</Grid>
					)
				})
			}
		</Grid>

	)
}

export default Tools
